<template>
  <b-sidebar
    :right="sideRight"
    shadow
    backdrop
    v-model="showSidebar"
    :width="propWidth"
    @change="visibleChanged"
    no-header
    prop
  >
    <b-sidebar
      :right="sideRight"
      shadow
      backdrop
      v-model="nestedSidebar"
      width="98%"
      @change="visibleChangedNested"
      no-header
      prop
    >
      <task-detail
        :id.sync="idNested"
        :hideMentionUsers="hideMentionUsers"
        @on-task-close="visibleChangedNested(false)"
        @on-task-delete="$emit('on-task-delete', $event)"
        class="detail-on-sidebar"
        @on-attendence="$emit('on-attendence', $event)"
      ></task-detail>
    </b-sidebar>
    <file-dialog
      :show="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />
    <task-detail
      :parentTask="parentTask"
      :id="id"
      :boxId="boxId"
      :hideMentionUsers="hideMentionUsers"
      @on-task-loaded="onLoaded"
      @on-attach="showAttach"
      :detailSettingProp="detailSettingProp"
      @on-task-detail="taskDetail"
      @on-task-reload="$emit('on-task-reload', $event)"
      @on-box-reload="$emit('on-box-reload', $event)"
      @on-task-delete="$emit('on-task-delete', $event)"
      @on-duplicated="$emit('on-duplicated', $event)"
      @on-row-updated="$emit('on-row-updated', $event)"
      @on-task-close="visibleChanged(false)"
      class="detail-on-sidebar"
      @on-edit-profile="$emit('on-edit-profile', $event)"
      @on-attendence="$emit('on-attendence', $event)"
    ></task-detail>
  </b-sidebar>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  name: "TaskDetailOnDialog",
  components: {
    taskDetail: () => ({
      component: import("@/components/task/detail/default.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    sideRight: {
      type: Boolean,
      default: () => true
    },
    id: {
      type: Number,
      default: () => 0
    },
    boxId: {
      type: Number,
      default: () => 0
    },
    show: {
      type: Boolean,
      default: () => false
    },
    parentTask: {
      type: Object,
      default: () => {}
    },
    detailSettingProp: {
      type: Object,
      default: () => null
    },
    propWidth: {
      type: String,
      default: () => "98%"
    },
    hideMentionUsers: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      loading: true,
      taskObj: {
        loaded: false,
        columns: [],
        task: {}
      },
      showSidebar: false,
      nestedSidebar: false,
      idNested: 0,
      fileDialog: {
        show: false,
        id: 0
      }
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    frmId() {
      return this.id;
    }
  },
  watch: {
    frmId(val) {
      if (val > 0) {
        this.init();
      }
    }
  },
  methods: {
    init() {
      //console.log('tsk dialog inited', this.id);
      this.showSidebar = true;
    },
    clearObj() {
      this.loading = true;
    },
    onLoaded(e) {
      this.taskObj.columns = e.columns;
      this.taskObj.task = e.task;
      this.taskObj.loaded = true;
      this.loading = false;
    },
    visibleChanged(e) {
      //console.log('vndsen sidebar haagdlaa');
      if (!e) {
        Object.assign(this.$data, this.$options.data());
        this.$emit("on-task-close");
      }
    },
    visibleChangedNested(e) {
      //console.log('nested haagdlaa');
      if (!e) {
        this.nestedSidebar = false;
      }
    },
    taskDetail(e) {
      //console.log('taskDetail=> ', e);
      this.idNested =
        e.obj != undefined && e.obj.id != undefined ? e.obj.id : e.id;
      this.nestedSidebar = true;
    },
    showAttach(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    }
  }
};
</script>
